import { useState } from "react";
import { devURL } from "../constants/constants";
import axios from 'axios';
import SelectStation from "../components/supplies/SelectStation";
import SupplyData from "../components/supplies/SupplyData";
import Loading from "../components/global/Loading";
import '../styles/supplies.css';

const STATION_NAMES = {
    AX001: "Świdnica, Towarowa 24",
    AX002: "Lubin, Ścinawska 20b",
    AX003: "Legnica, Piłsudskiego 70",
};

export default function Supplies() {
    const [ station, setStation ] = useState("AX001");
    const [ data, setData ] = useState(null);
    const [ loading, setLoading ] = useState(false);
    const [ fetchedStation, setFetchedStation ] = useState(null);

    const getData = async () => {
        try {
            setLoading(true);
            setData(null);
            const response = await axios({
                method: 'get',
                url: `${devURL}/fuel-supply?station=${station}&_=${Date.now()}`,
                headers: {
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Pragma': 'no-cache'
                }
            });
            setData(response.data);
            setFetchedStation(station);
        } catch(error) {
            console.log(error)
        } finally {
            setLoading(false);
        }
    };

console.log(data)

    return (
        <div className="supplies">
            <SelectStation station={station} setStation={setStation} onFetch={getData}/>
            { loading && <Loading/> }
            { !loading && data && (
                <>
                    <p className="supply-station-name">{STATION_NAMES[fetchedStation] ?? fetchedStation}</p>
                    <SupplyData data={data}/>
                </>
            ) }
        </div>
    )
}
